import React, { Component } from 'react';
import { Menu } from '../../components';
import s from './HostStyles.module.scss';

export default class MenuEditor extends Component {
    constructor(props) {
        super(props);
        this.state = { selectedIcon: null };
    }

    onIconChange = newId => this.setState({ selectedIcon: newId });

    render() {
        return (
            <div className={s.editor}>
                <Menu selectedIcon={this.state.selectedIcon} onChange={this.onIconChange} />
            </div>
        );
    }
}
